import { render, staticRenderFns } from "./DownloadFileForm.vue?vue&type=template&id=2d98ed54&"
import script from "./DownloadFileForm.vue?vue&type=script&lang=js&"
export * from "./DownloadFileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports